:host {
  display: flex;
  width: 100%;

  .count {
    color: var(--neutral-grey-secondary, #707070);
  }

  sl-checkbox {
    display: flex;
    width: 100%;

    &::part(control) {
      height: 1rem;
      width: 1rem;
      border: 1px solid var(--neutral-grey-secondary, #707070);
      border-radius: 3px;
      margin-top: 3px;
    }

    &::part(control--checked) {
      background-color: var(--status-interaction-standard, #2C6ECB);
      border-color: var(--status-interaction-standard, #2C6ECB);
      color: var(--neutral-ultralight, #fff);
    }

    &::part(label) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      flex-grow: 1;
      color: var(--neutral-grey-primary, #1d1d1d);
      font-family: var(--ff-primary), serif;
    }
  }
}
